import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import {
  CheckoutPersonalInfoRequest,
  CheckoutPersonalInfoResponse,
  PurchaseLimitValidationResponse,
} from '@core/dto/checkout.dto';
import { Locale } from '@core/enums/locale';
import { environment } from '@env';
import { HtmlParamEncoder } from '@shared/utils/http-param-encoder';
import { getCulture } from '@shared/utils/locale-utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {
  baseUrl: string = environment.ecommerceBackendUri;
  options = { withCredentials: true };
  culture: Locale;

  constructor(
    private http: HttpClient,
    @Inject(LOCALE_ID) private localeId: Locale,
  ) {
    this.culture = getCulture(localeId);
  }

  addressValidation(
    request: CheckoutPersonalInfoRequest,
  ): Observable<CheckoutPersonalInfoResponse> {
    return this.http.post<CheckoutPersonalInfoResponse>(
      `${this.baseUrl}api/checkout/personalInfo`,
      request,
      this.options,
    );
  }

  checkEmail(email: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/user/check`, {
      params: new HttpParams({ fromObject: { email } }),
    });
  }

  checkUserPrincipal(userPrincipalName: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}api/user/checkUser`, {
      params: new HttpParams({
        encoder: new HtmlParamEncoder(),
        fromObject: {
          userPrincipalName: userPrincipalName,
        },
      }),
    });
  }

  purchaseLimitValidation(): Observable<PurchaseLimitValidationResponse> {
    return this.http.post<PurchaseLimitValidationResponse>(
      `${this.baseUrl}api/checkout/purchaseLimitValidation`,
      {},
      {
        ...this.options,
        params: new HttpParams({ fromObject: { culture: this.culture } }),
      },
    );
  }
}
